import { bus } from '@/event-bus';
import { BASE_URL, opportunityDocumentsService } from '@/services/opportunity-documents.service';
import axios from 'axios';

const initialState = () => ({
  opportunityDocument: null,
  statusPerOpportunity: {},
});

const state = initialState();

const actions = {
  getDocument({ commit }, { opportunityId, documentId, cancelToken }) {
    commit('GET_DOCUMENT', opportunityId);
    return opportunityDocumentsService.getDocument({ opportunityId, documentId, cancelToken }).then(
      (document) => {
        commit('GET_DOCUMENT_SUCCESS', { opportunityId, document });
        return document;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', { opportunityId, error });
          throw error;
        }
      },
    );
  },
  addDocuments({ commit }, { opportunity, formData }) {
    const opportunityId = opportunity.id;

    commit('UPDATING_DOCUMENTS', opportunityId);

    return opportunityDocumentsService.addDocuments({ opportunityId, formData }).then(
      (documents) => {
        commit('opportunities/SUCCESS_ADDING_DOCUMENTS', { opportunityId, documents }, { root: true });
        commit('tenderOpportunities/SUCCESS_ADDING_DOCUMENTS', { opportunityId, documents }, { root: true });
        commit('opportunity/SUCCESS_ADDING_DOCUMENTS', { opportunityId, documents }, { root: true });
        return commit('SUCCESS_UPDATING_DOCUMENTS', opportunityId);
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', { opportunityId, error });
          throw error;
        }
      },
    );
  },
  deleteDocument({ commit }, { opportunity, documentId }) {
    const opportunityId = opportunity.id;

    commit('UPDATING_DOCUMENTS', opportunityId);

    return opportunityDocumentsService.deleteDocument({ opportunityId, documentId }).then(
      () => {
        commit('opportunities/SUCCESS_DELETING_DOCUMENT', { opportunityId, documentId }, { root: true });
        commit('tenderOpportunities/SUCCESS_DELETING_DOCUMENT', { opportunityId, documentId }, { root: true });
        commit('opportunity/SUCCESS_DELETING_DOCUMENT', { opportunityId, documentId }, { root: true });
        return commit('SUCCESS_UPDATING_DOCUMENTS', opportunityId);
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', { opportunityId, error });
          throw error;
        }
      },
    );
  },
  async setCurrentDocument({ commit, dispatch }, { document, manualChange, cancelToken }) {
    commit('pdfData/SET_PDF_URL', null, { root: true });

    if (!document || typeof document !== 'object' || !document.id || !document.opportunityId) {
      console.error('Invalid document object:', document);
      return;
    }

    commit('PREPARE_CURRENT_DOCUMENT', document);
    const { id, opportunityId } = document;

    try {
      opportunityDocumentsService.getDocument({ opportunityId, documentId: id, cancelToken }).then(async (document) => {
        let pdfUrl = `${BASE_URL}/${opportunityId}/documents/${id}/file`;
        await dispatch('pdfData/setPdfUrl', { pdfUrl }, { root: true });
        commit('SET_CURRENT_DOCUMENT', { document });

        if (manualChange) {
          bus.$emit('scroll-to-page', 1);
        }
      });
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error('Error fetching document:', error);
        commit('ERROR', { opportunityId, error });
        throw error;
      }
    }
  },
  RESET({ commit }) {
    commit('RESET_STORE');
  },
};

const mutations = {
  GET_DOCUMENT(state, opportunityId) {
    state.statusPerOpportunity = {
      ...state.statusPerOpportunity,
      [opportunityId]: {
        error: null,
        pending: true,
        resolved: false,
        rejected: false,
      },
    };
  },
  GET_DOCUMENT_SUCCESS(state, { opportunityId, document }) {
    delete state.statusPerOpportunity[opportunityId];
    state.statusPerOpportunity = { ...state.statusPerOpportunity }; // to refresh the state
    state.opportunityDocument = document;
  },
  PREPARE_CURRENT_DOCUMENT(state, document) {
    state.opportunityDocument = document;
  },
  SET_CURRENT_DOCUMENT(state, { document }) {
    if (document) state.opportunityDocument = document;
  },
  ERROR(state, { opportunityId, error }) {
    state.statusPerOpportunity = {
      ...state.statusPerOpportunity,
      [opportunityId]: {
        error: error,
        pending: false,
        resolved: true,
        rejected: true,
      },
    };
  },
  UPDATING_DOCUMENTS(state, opportunityId) {
    state.statusPerOpportunity = {
      ...state.statusPerOpportunity,
      [opportunityId]: {
        error: null,
        pending: true,
        resolved: false,
        rejected: false,
      },
    };
  },
  SUCCESS_UPDATING_DOCUMENTS(state, opportunityId) {
    delete state.statusPerOpportunity[opportunityId];
    state.statusPerOpportunity = { ...state.statusPerOpportunity }; // to refresh the state
  },
  RESET_STORE(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const getters = {
  opportunityDocument: (state) => state.opportunityDocument,
  opportunityDocuments: (state, getters, rootState, rootGetters) => rootGetters['opportunity/documents'],

  // status
  status: (state) => state.statusPerOpportunity,
};

export const opportunityDocuments = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
